export default "__VITE_ASSET__B$hYbj0J__"